/* eslint-disable no-useless-escape */
export const name = /^[A-Za-z]+$/i;
export const email = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/i;
export const mobile = /^[0]?[789]\\d{9}$/i;
export const mobileRegex = /^\s*([1-9]{1}[0-9]{9})\s*$/;
export const aadhaarNumberRegex = /^\d{12}$/i;
export const emailRegex = /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
export const urlRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;